import { useEffect, useRef, useState } from "react";
import "./ShowCardPCIProxy.scss";
import { useTranslation } from "react-i18next";


declare global {
  interface Window {
    SecureFields: any;
  }
}

interface CardShowPCIProxyProps {
  transactionId: string;
  expiryDate?: string;
}

const ShowCardPCIProxy = ({ transactionId, expiryDate }: CardShowPCIProxyProps) => {
  const secureFieldsRef = useRef<any>(null);
  const [log, setLog] = useState<string[]>([]);
  const { t } = useTranslation();

  const addLog = (msg: string) => {
    setLog((l) => [...l, msg]);
  };

  const initShow = () => {
    if (!transactionId) {
      addLog("No transactionId provided");
      return;
    }

    if (secureFieldsRef.current) {
      secureFieldsRef.current.destroy();
    }

    if (!window.SecureFields) {
      addLog("ERROR: SecureFields not loaded");
      return;
    }

    const sf = new window.SecureFields();
    secureFieldsRef.current = sf;

    addLog("Init show with ID: " + transactionId);

    sf.init(transactionId, {
      cardNumber: { placeholderElementId: "card-number" },
      cvv: { placeholderElementId: "cvv-number" },
    });

    sf.on("ready", () => {
      addLog("READY: Secure Fields rendered");
    });

    sf.on("error", (e: any) => {
      addLog("ERROR: " + JSON.stringify(e));
    });
  };

  useEffect(() => {
    // cargar script una sola vez
    if (window.SecureFields) {
      initShow();
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://pay.sandbox.datatrans.com/upp/payment/js/secure-fields-2.0.0.min.js";
    script.async = true;

    script.onload = () => {
      addLog("SecureFields script loaded");
      initShow();
    };

    script.onerror = () => {
      addLog("ERROR loading SecureFields script");
    };

    document.body.appendChild(script);

    return () => {
      secureFieldsRef.current?.destroy?.();
    };
  }, [transactionId]);

  return (
    <div className="pci-card-fields">

      {/* Número de tarjeta */}
      <div className="pci-field pci-field-card">
        <div className="pci-label">
          {t("pages.booking-detail.card-number")}
        </div>
        <div id="card-number" className="pci-input" />
      </div>

      {/* CVV */}
      <div className="pci-field pci-field-cvv">
        <div className="pci-label">
          {t("pages.booking-detail.CVV")}
        </div>
        <div id="cvv-number" className="pci-input" />
      </div>

      {/* Fecha */}
      <div className="pci-field pci-field-expiry">
        <div className="pci-label">
          {t("pages.booking-detail.expiration-date")}
        </div>
        <div className="pci-input pci-input-readonly">
          {expiryDate}
        </div>
      </div>

    </div>
  );


};

export default ShowCardPCIProxy;
